// Presentation only: preserve community IDs and palette slots across releases.
// Brighter versions of the same hue families, shared by fog, nodes and labels.
const muted = ["#a88c70","#709e9b","#938eb0","#8b9e71","#b17d83","#738ea9","#a5a073","#9d819c","#779989","#ab927f","#879cb0","#999174"];
const vivid = ["#e7aa68","#52c6b9","#b29aee","#9bc96a","#ec899b","#73ace8","#d5cd68","#d591d0","#62c99a","#e3a184","#8ebde9","#c8b575"];
export function territoryColor(color) {
  const index = muted.indexOf(color);
  return index < 0 ? color : vivid[index];
}
export function labelInk(color, priority = false) {
  if (priority) return "#fff9eb";
  if (!/^#[0-9a-f]{6}$/i.test(color || "")) return "#dee5e2";
  // Mostly light ink, with just enough shared hue to orient a reader.
  return "#" + [1,3,5].map(i => Math.round(parseInt(color.slice(i,i+2),16)*.38+245*.62).toString(16).padStart(2,"0")).join("");
}
